import { FC, MouseEvent, ReactNode, useRef } from "react";
import styles from "./index.module.scss";
import CloseButton from "@/assets/images/Close";
import classNames from "classnames";

export interface ModalProps {
  children: ReactNode;
  title: string;
  onClose: () => void;
  visible?: boolean;
  modalClassName?: string;
  contentClassName?: string;
}

type OnClickEvent = MouseEvent<HTMLDivElement, globalThis.MouseEvent>;

const Modal: FC<ModalProps> = ({
  children,
  title,
  onClose,
  visible = true,
  modalClassName,
  contentClassName,
  ...rest
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  const onContainerClick = (e: OnClickEvent) => {
    if (!modalRef.current?.contains(e.target as Node)) onClose();
  };

  if (!visible) return null;
  return (
    <div className={styles.container} onClick={onContainerClick} {...rest}>
      <div className={classNames(styles.modal, modalClassName)} ref={modalRef}>
        <div className={styles.topBar}>
          <h2>{title}</h2>
          <CloseButton
            onClick={onClose}
            className={styles.closeButton}
            data-cy="modal-close-button"
          />
        </div>
        <div className={classNames(styles.contentBox, contentClassName)}>{children}</div>
      </div>
    </div>
  );
};

export default Modal;
